import { RefObject, useMemo, useRef, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TwoColTemplate from '@gym-templates/TwoColTemplate/TwoColTemplate';
import { AlertType } from '@gym-atoms/Alert/Alert';
import { Card } from 'primereact/card';
import { useAppSelector } from '@gym-redux/store';
import GymChainProgramAccessCategoryInfoTemplate from '../../templates/GymChainProgramAccessCategoryInfo/GymChainProgramAccessCategoryInfo';
import {
  GymChainProgramAccessCategory,
  GymChainProgramAccessCategoryTable
} from '../../../particles/types/GymChainProgramAccessCategory';

const MainColumn = (props: { alertRef: RefObject<AlertType>; backPath: string }) => {
  const location = useLocation<{
    from?: string;
    gymId?: number;
    programAccessCategory?: GymChainProgramAccessCategoryTable;
  }>();
  const { gymChainProgramAccessCategoryId, chainId } = useParams<{
    gymChainProgramAccessCategoryId: string;
    chainId: string;
    gymId?: string;
  }>();
  console.log(gymChainProgramAccessCategoryId, chainId);

  const gymChainProgramAccessCategory = useAppSelector((state) =>
    state.gymChainProgramAccessCategories.items
      .find((g) => g.siteId === +chainId)
      ?.items.find((g) => g.id === +gymChainProgramAccessCategoryId)
  );
  console.log({ gymChainProgramAccessCategory });
  const { t } = useTranslation();
  const [
    gymChainProgramAccessCategoryState,
    setGymChainProgramAccessCategoryState
  ] = useState<GymChainProgramAccessCategory>();

  const createGymChainProgramAccessCategory = async () => {
    if (location.state?.programAccessCategory) {
      const locationProgramAccessCategory = location.state.programAccessCategory;
      const firstProgramDetail = locationProgramAccessCategory.programAccessCategoryDetails[0];

      setGymChainProgramAccessCategoryState({
        id: locationProgramAccessCategory.id,
        siteId: locationProgramAccessCategory.siteId,
        name: locationProgramAccessCategory.name,
        gender: locationProgramAccessCategory.gender,
        age: locationProgramAccessCategory.age || 0,
        schedulesOnly: locationProgramAccessCategory.schedulesOnly,
        status: locationProgramAccessCategory.status,
        programs: [],
        arxAccessCategoryId: firstProgramDetail?.arxAccessCategoryId || ''
      });
      return;
    }

    const items = {
      id: gymChainProgramAccessCategory?.id || 0,
      siteId: gymChainProgramAccessCategory?.siteId || 0,
      name: gymChainProgramAccessCategory?.name || '',
      gender: gymChainProgramAccessCategory?.gender || '',
      age: gymChainProgramAccessCategory?.age || 0,
      schedulesOnly: gymChainProgramAccessCategory?.schedulesOnly ? 'true' : 'false',
      status: gymChainProgramAccessCategory?.status || '',
      programs: [],
      arxAccessCategoryId: gymChainProgramAccessCategory?.arxAccessCategoryId || ''
    };
    console.log({ items });

    setGymChainProgramAccessCategoryState(items);
  };

  useMemo(() => {
    createGymChainProgramAccessCategory();
  }, []);

  return (
    <Card className="pt30 pl40 pr40 pb30">
      <GymChainProgramAccessCategoryInfoTemplate
        alertRef={props.alertRef}
        alertMessage={t('MODIFY_MEMBERSHIP.ALERT_MESSAGE_SUCCESS')}
        programAccessCategory={gymChainProgramAccessCategoryState}
        type={'modify'}
        backPath={props.backPath}
      />
    </Card>
  );
};

const ModifyGymChainProgramAccessCategoryPage = () => {
  const { t } = useTranslation();
  const alertRef = useRef<AlertType>(null);
  const history = useHistory();
  const location = useLocation<{ from?: string; gymId?: number }>();
  const { chainId, gymId } = useParams<{ chainId: string; gymId?: string }>();
  const locationGymId = location.state?.gymId || (gymId ? +gymId : undefined);
  const backPath =
    location.state?.from === 'chain' || !locationGymId
      ? `/gymChains/${chainId}/gymChainAccessCategories`
      : `/gymChains/${chainId}/gyms/${locationGymId}/gymAccessCategories`;
  const backState = { accessCategoryTab: 'bookings' };

  return (
    <TwoColTemplate
      title={t('MODIFY_GYM_ACCESS_CATEGORY.PAGE_TITLE')}
      gymChainId={+chainId}
      col1={<MainColumn alertRef={alertRef} backPath={backPath} />}
      alertRef={alertRef}
      backButtonHandler={() => history.push(backPath, backState)}
    />
  );
};
export default ModifyGymChainProgramAccessCategoryPage;
